import React from "react";
import { noCodePoints, customCodePoints } from "./graphData";
import { buildSmoothPath, scaleX, scaleY } from "./curveUtils";
import "./revenue-graph.css";

const WIDTH = 1100;
const HEIGHT = 350;
const BASELINE = 360;

const RevenueGraph = () => {
  return (
    <div className="revenue-graph-wrapper">
      <svg
        viewBox={`0 0 ${WIDTH} 420`}
        preserveAspectRatio="xMidYMid meet"
        className="revenue-graph"
      >
        {/* X axis */}
        <line
          x1="0"
          y1={BASELINE}
          x2={WIDTH}
          y2={BASELINE}
          className="axis"
        />

        {/* Curves */}
        <path
          d={buildSmoothPath(noCodePoints, WIDTH, HEIGHT)}
          className="curve no-code animate-path"
        />

        <path
          d={buildSmoothPath(customCodePoints, WIDTH, HEIGHT)}
          className="curve custom-code animate-path"
        />

        {/* Vertical dashed markers */}
        {noCodePoints.map((p, i) => {
          const x = scaleX(p.x, WIDTH);
          const y = scaleY(p.y, HEIGHT);

          return (
            <line
              key={`marker-${i}`}
              x1={x}
              y1={BASELINE}
              x2={x}
              y2={y}
              className="marker"
            />
          );
        })}

        {/* Circles */}
        {noCodePoints.map((p, i) => {
          const x = scaleX(p.x, WIDTH);
          const y = scaleY(p.y, HEIGHT);

          return (
            <circle
              key={`point-${i}`}
              cx={x}
              cy={y}
              r="6"
              className={`point delay-${i + 1}`}
            />
          );
        })}

        {/* Labels */}
        {noCodePoints.map((p, i) => {
          if (!p.label) return null;

          return (
            <text
              key={`label-${i}`}
              x={scaleX(p.x, WIDTH) - 30}
              y={scaleY(p.y, HEIGHT) - 12}
              className="label"
            >
              {p.label}
            </text>
          );
        })}

        {/* Timeline */}
        <text x={scaleX(0, WIDTH)} y="395" className="timeline">0</text>
        <text x={scaleX(20, WIDTH)} y="395" className="timeline">2w</text>
        <text x={scaleX(40, WIDTH)} y="395" className="timeline">10w</text>
        <text x={scaleX(60, WIDTH)} y="395" className="timeline">12w</text>
        <text x={scaleX(100, WIDTH) - 40} y="395" className="timeline">30w</text>

        {/* Legends */}
        <text x={scaleX(75, WIDTH)} y="120" className="legend no-code-text">
          No-code
        </text>
        <text x={scaleX(75, WIDTH)} y="330" className="legend custom-code-text">
          Custom code
        </text>
      </svg>
    </div>
  );
};

export default RevenueGraph;
